import React from "react";
import classNames from "classnames";
import { SectionTilesProps } from "../../utils/SectionProps";
import SectionHeader from "./partials/SectionHeader";
import testimonials from "../../testimonials.json";

const propTypes = {
  ...SectionTilesProps.types,
};
const defaultProps = {
  ...SectionTilesProps.defaults,
};

const Testimonial1 = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const outerClasses = classNames(
    "testimonial section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "testimonial-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );


  const sectionHeader = {
    title: "Client testimonials",
    paragraph: "Know what our clients say about us...",
  };

  return (
    <section {...props} className={outerClasses}>
      <div className="container noselect">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <ul className="flex-container-stack-grid testimony-slideshow">
            {testimonials
              .sort(() => Math.random() - 0.5)
              .map((testimony, index) => {
                return (
                  <li
                    key={testimony.index+'' + Math.random()}
                    className="flex-item-stack-grid testimonial-paper testimony-mover"
                  >
                    <i>"{testimony.testimony}"</i>
                    <br />

                    <span className="testimonial-item-link">
                      - <b>{testimony.name}</b>
                    </span>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </section>
  );
};

Testimonial1.propTypes = propTypes;
Testimonial1.defaultProps = defaultProps;

export default Testimonial1;
